// extracted by mini-css-extract-plugin
module.exports = {"tracks":"collection-TrackCollection__tracks--2OZnl","infiniteScroll":"collection-TrackCollection__infiniteScroll---xTKo"};